import { ErrorHandler, Injectable } from "@angular/core";
import { ErrorService } from "@shared-services/error.service";

@Injectable({
  providedIn: 'root' // Single instance provided in root
})
export class GenericErrorHandler implements ErrorHandler {
  constructor(private errorService: ErrorService) { }

  handleError(error: any): void {
    if (error) {
      console.error(error);
      this.errorService.logError(error.message, "Angular GenericErrorHandler handleError", error);
    }
  }
}
